import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Grid } from '@dhl-ui/components'
import { BackButton } from '~/temp-ds-component/BackButton'
import { links } from '~/AppRoutes'
import { DangerZoneCard } from '~/common/components/DangerZoneCard'
import { IntegratorCard, IntegratorDangerZoneDialog } from '~/modules/integrators/components'

type Params = {
  id: string
}

export const IntegratorDetailsPage = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { id } = useParams<Params>()
  const [dangerZoneOpen, setDangerZoneOpen] = useState<boolean>(false)

  const onBack = () => {
    navigate(links.integratorsLink())
  }

  const onClickOpen = () => {
    id && setDangerZoneOpen(true)
  }

  const dangerZoneContent = {
    title: t('admin.integratorsPage.dangerZoneTitle'),
    subtitle: t('admin.integratorsPage.deleteButtonTitle'),
    value: t('admin.integratorsPage.dangerZoneMessage'),
    button: t('admin.integratorsPage.dangerZoneHeader'),
    id: id,
  }

  return (
    <>
      <Grid>
        <Box marginBottom={2}>
          <BackButton onClick={onBack}>{t('admin.integratorsPage.backButtonTitle')}</BackButton>
        </Box>
      </Grid>
      {id && (
        <Grid size={{ xs: 9 }}>
          <IntegratorCard id={id} onEdit={() => navigate(links.editIntegratorDetailsLink(id))} />
        </Grid>
      )}
      <Grid size={{ xs: 9 }}>
        <Box marginTop={2}>
          <DangerZoneCard dangerZoneContent={dangerZoneContent} onClickOpen={onClickOpen} />
        </Box>
      </Grid>
      {id && (
        <IntegratorDangerZoneDialog
          open={dangerZoneOpen}
          id={id}
          onClose={() => setDangerZoneOpen(false)}
          onDeleteComplete={onBack}
        />
      )}
    </>
  )
}
